import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Typography } from "antd";

import colors from "../styles/globalColors";
const { Title: ATitle } = Typography;

export default (props: {
  children: any;
  bold?: boolean;
  padded?: boolean;
  style?: any;
}) => {
  const { children, bold, padded, style } = props;
  return (
    <ATitle
      level={4}
      css={[
        {
          color: colors.black,
          fontWeight: bold ? 600 : 300,
          marginTop: 0,
          paddingBottom: padded ? 15 : 0
        },
        style
      ]}
    >
      {children}
    </ATitle>
  );
};
